import React from "react";
import LockOverlay from "../../LockOverlay/LockOverlay";

const ReportingTabContent = () => <LockOverlay redirect="request_access" />;

export default ReportingTabContent;
